import { render, staticRenderFns } from "./PracicasAlumnos.vue?vue&type=template&id=78ef0fc7&scoped=true&"
import script from "./PracicasAlumnos.vue?vue&type=script&lang=js&"
export * from "./PracicasAlumnos.vue?vue&type=script&lang=js&"
import style0 from "./PracicasAlumnos.vue?vue&type=style&index=0&id=78ef0fc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ef0fc7",
  null
  
)

export default component.exports